/**
 * Attend qu'un élément DOM soit disponible dans le document et exécute un callback.
 * Si l'élément existe déjà, le callback est appelé immédiatement.
 * Sinon, la fonction observe les mutations du DOM jusqu'à ce que l'élément apparaisse.
 * 
 * @param {string} selector - Le sélecteur CSS de l'élément à attendre
 * @param {Function} callback - La fonction à exécuter une fois l'élément trouvé, reçoit l'élément en paramètre
 * @returns {void}
 */
function waitForElement(selector, callback) {
    const element = document.querySelector(selector);
    if (element) {
        callback(element);
        return;
    }
    
    const observer = new MutationObserver((_, obs) => {
        const element = document.querySelector(selector);
        if (element) {
            obs.disconnect();
            callback(element);
        }
    });
    
    const targetNode = document.body || document.documentElement;
    observer.observe(targetNode, {
        childList: true,
        subtree: true
    });
}

waitForElement('#add-product-checkbox', function(addProductCheckbox) {

    // Function to sync checkbox state with actual cart contents
    function syncCheckboxWithCart() {
        const checkbox = document.querySelector('#add-product-checkbox');
        if (!checkbox) return;
        
        // Check if specific addon product is still in cart
        if (typeof jQuery !== 'undefined' && typeof wc_add_to_cart_params !== 'undefined') {
            jQuery.post(wc_add_to_cart_params.ajax_url, {
                action: 'check_addon_product_in_cart'
            }, function(response) {
                if (response && response.success && response.data) {
                    checkbox.checked = response.data.in_cart;
                }
            });
        }
    }

    // Sync on page load
    syncCheckboxWithCart();

    // Listen for cart update events
    if (typeof jQuery !== 'undefined') {
        jQuery(document.body).on('removed_from_cart updated_cart_totals wc_fragments_refreshed wc_fragments_loaded', syncCheckboxWithCart);
    }
    
    document.addEventListener('change', function(event) {
        if (event.target.id === 'add-product-checkbox') {
            handleCheckboxChange(event);
        }
    });

    document.addEventListener('click', function(event) {
        if (event.target.id === 'add-product-checkbox') {
            handleCheckboxChange(event);
        }
    });
    
    function handleCheckboxChange(event) {
        const add = event.target.checked;
        const loader = document.querySelector('.addon-loading');
        
        // console.log('Checkbox is now: ' + (add ? 'checked' : 'unchecked'));        
        
        if (loader) {
            loader.style.display = 'inline-block';
        }

        // Function to hide loader after mini-cart refresh
        const hideLoaderAfterRefresh = () => {
            if (typeof jQuery !== 'undefined') {
                jQuery(document).one('wc_fragments_refreshed', function() {
                    if (loader) {
                    loader.style.display = 'none';
                    }
                });
                
                // Fallback timeout in case event doesn't fire
                setTimeout(() => {
                    if (loader) {
                    loader.style.display = 'none';
                    }
                }, 3000);
            } else if (loader) {
                loader.style.display = 'none';
            }
        };

        if (window.wc && window.wc.blocksCheckout) {
            // console.log('Using wc.blocksCheckout to update cart');
            const { extensionCartUpdate } = window.wc.blocksCheckout;
            extensionCartUpdate({
                namespace: 'custom-cart-product',
                data: {
                    checked: add
                }
            }).then(() => {
                // Refresh mini-cart
                if (typeof jQuery !== 'undefined') {
                    jQuery(document.body).trigger('wc_fragment_refresh');
                    hideLoaderAfterRefresh();
                } else if (loader) {
                    loader.style.display = 'none';
                }
            });
        } else {
            // console.log('Using AJAX to update cart');
            // For checkout page, use AJAX
            if (typeof jQuery !== 'undefined' && typeof wc_add_to_cart_params !== 'undefined') {
                jQuery.post(wc_add_to_cart_params.ajax_url, {
                    action: 'toggle_addon_product',
                    checked: add
                }, function(response) {
                    if (response && response.action === 'removed') {
                        // Handle removed action
                        event.target.checked = false;
                    } else if (response && response.action === 'subscription') {
                        // console.log('subscription');
                    }

                    jQuery('body').trigger('update_checkout');
                    // Refresh mini-cart
                    jQuery(document.body).trigger('wc_fragment_refresh');
                    hideLoaderAfterRefresh();
                    
                    // Re-sync checkbox state after operation
                    setTimeout(syncCheckboxWithCart, 500);
                });
            } else if (loader) {
                loader.style.display = 'none';
            }
        } 
    }
    addProductCheckbox.addEventListener('change', handleCheckboxChange);
});

/**
 * Met à jour la barre de progression pour la livraison gratuite en fonction du total du panier.
 * 
 * Cette fonction calcule le pourcentage de progression vers le seuil de livraison gratuite,
 * met à jour visuellement la barre de progression et affiche un message approprié :
 * - Si le seuil est atteint : affiche un message de confirmation
 * - Sinon : affiche le montant restant à atteindre
 * 
 * @param {number} total - Le montant total actuel du panier en euros
 */
function updateFreeShippingBar(total) {
    const progressBarInner = document.querySelector('.myf-progress-bar__inner');
    if (!progressBarInner) return;
    const max = parseFloat(progressBarInner.getAttribute('data-max')) || 60;
    const progress = Math.min((total / max) * 100, 100);
    const progressBarText = document.querySelector('.myf-progress-bar__inner');

    progressBarInner.style.width = progress + '%';
    if (progressBarText && total >= max) {
        progressBarText.innerHTML = '<p class="myf-progress-bar__text myf-progress-bar__text--full"><strong>La livraison vous est offerte</strong></p>';
    } else {
        progressBarText.innerHTML = '<p class="myf-progress-bar__text myf-progress-bar__text--float"><strong>Plus que <span>' + (max - total).toFixed(2) + '</span>€</strong> pour avoir la livraison offerte</p>';
    }
}
 
/**
 * Surveille les appels API batch de WooCommerce pour détecter les modifications du panier.
 * Met à jour la checkbox du produit addon et la barre de progression de livraison gratuite.
 */
if ((document.body.classList.contains('woocommerce-cart') || document.body.classList.contains('woocommerce-checkout')) && typeof PerformanceObserver !== 'undefined') {
    const observer = new PerformanceObserver((list) => {
        for (const entry of list.getEntries()) {
            if (entry.name && entry.name.includes('/wp-json/wc/store/v1/batch')) {
                const checkbox = document.querySelector('#add-product-checkbox');
                
                // Check if addon product is still in cart and update checkbox
                if (checkbox && typeof jQuery !== 'undefined' && typeof wc_add_to_cart_params !== 'undefined') {
                    jQuery.post(wc_add_to_cart_params.ajax_url, {
                        action: 'check_addon_product_in_cart'
                    }, function(response) {
                        // Update checkbox based on actual cart state
                        if (response && response.success && response.data) {
                            checkbox.checked = response.data.in_cart;
                        }
                    });
                }
                
                // Refresh free shipping bar
                if (typeof jQuery !== 'undefined' && typeof frontendajax !== 'undefined') {
                    jQuery.ajax({
                        url: frontendajax.ajaxurl,
                        type: 'POST',
                        data: {
                            action: 'myf_get_cart_total'
                        },
                        success: function(response) {
                            if (response && response.data !== undefined) {
                                updateFreeShippingBar(response.data);
                            }
                        }
                    });
                }
            }
        }
    });
    
    observer.observe({ entryTypes: ['resource'] });
}

// Sur la page panier classique, WooCommerce applique les règles prix
// lors de la soumission du formulaire. On automatise ce submit au changement de quantité.
if (document.body.classList.contains('woocommerce-cart') && typeof jQuery !== 'undefined') {
    (function($) {
        var cartUpdateDebounce;

        $(document).on('change input', '.woocommerce-cart-form input.qty', function() {
            clearTimeout(cartUpdateDebounce);

            cartUpdateDebounce = setTimeout(function() {
                var $form = $('.woocommerce-cart-form');
                if (!$form.length) {
                    return;
                }

                var $updateButton = $form.find('button[name="update_cart"]');
                if ($updateButton.length && $updateButton.prop('disabled')) {
                    $updateButton.prop('disabled', false);
                }

                $form.trigger('submit');
            }, 350);
        });
    })(jQuery);
}

// Panier WooCommerce Blocks: forcer un recalcul des remises après changement de quantité.
if ((document.body.classList.contains('woocommerce-cart') || document.body.classList.contains('woocommerce-checkout')) && window.wc && window.wc.blocksCheckout && typeof window.wc.blocksCheckout.extensionCartUpdate === 'function') {
    (function() {
        var recalcDebounce;

        function refreshBlocksCartStore() {
            if (!window.wp || !window.wp.data || typeof window.wp.data.dispatch !== 'function') {
                return;
            }

            var cartDispatch = window.wp.data.dispatch('wc/store/cart');
            if (!cartDispatch) {
                return;
            }

            if (typeof cartDispatch.invalidateResolutionForStore === 'function') {
                cartDispatch.invalidateResolutionForStore();
                return;
            }

            if (typeof cartDispatch.invalidateResolution === 'function') {
                cartDispatch.invalidateResolution('getCartData', []);
            }
        }

        function requestDiscountRecalc() {
            clearTimeout(recalcDebounce);

            recalcDebounce = setTimeout(function() {
                window.wc.blocksCheckout.extensionCartUpdate({
                    namespace: 'custom-cart-discount-recalc',
                    data: {
                        source: 'qty-change',
                        at: Date.now()
                    }
                }).then(function() {
                    refreshBlocksCartStore();
                }).catch(function() {
                    // Fallback: tenter un refresh explicite du store cart.
                    refreshBlocksCartStore();
                });
            }, 450);
        }

        // Le champ quantité des blocks émet souvent input puis change au blur.
        document.addEventListener('input', function(event) {
            if (event.target && event.target.matches && event.target.matches('.wc-block-components-quantity-selector__input')) {
                requestDiscountRecalc();
            }
        });

        document.addEventListener('change', function(event) {
            if (event.target && event.target.matches && event.target.matches('.wc-block-components-quantity-selector__input')) {
                requestDiscountRecalc();
            }
        });

        document.addEventListener('click', function(event) {
            if (event.target && event.target.closest && event.target.closest('.wc-block-components-quantity-selector__button')) {
                requestDiscountRecalc();
            }
        });
    })();
}